import React from 'react';
import { ShieldCheckIcon, TargetIcon, AwardIcon, UsersIcon } from 'lucide-react';
export function ProgramDetails() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2048">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2049">
        <div className="mb-12" data-id="element-2050">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2051">
            Program Details
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2052">
            <div className="space-y-6" data-id="element-2053">
              <div className="flex items-start gap-4" data-id="element-2054">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-2055">
                  <ShieldCheckIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-2056" />
                </div>
                <div data-id="element-2057">
                  <h3 className="text-base font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-2058">
                    Safety First
                  </h3>
                  <p className="text-base mb-2" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2059">
                    A two-hour rifle familiarization and safety course is
                    required before the first night of shooting. This training
                    starts providing the student with basic attitudes and skills
                    to safely use a firearm.
                  </p>
                  <p className="text-sm" style={{
                  color: '#5a5a5a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2060">
                    Range sessions are supervised by NRA Certified Instructors
                    and/or NRA Certified Range Safety Officers.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-2061">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-2062">
                  <TargetIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-2063" />
                </div>
                <div data-id="element-2064">
                  <h3 className="text-base font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-2065">
                    Equipment & Course of Fire
                  </h3>
                  <p className="text-base mb-2" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2066">
                    The club provides rifles and ammunition. Families with an
                    appropriate firearm may ask to have it approved by the Chief
                    Instructor for use.
                  </p>
                  <p className="text-base" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2067">
                    The course of fire used is the National Rifle Association /
                    Civilian Marksmanship Program's 4 position small bore rifle
                    qualification.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-2068">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-2069">
                  <AwardIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-2070" />
                </div>
                <div data-id="element-2071">
                  <h3 className="text-base font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-2072">
                    Progression & Achievement
                  </h3>
                  <p className="text-base mb-2" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2073">
                    Shooters who complete the program will gain proficiency in
                    prone, sitting, kneeling, and offhand (standing) positions.
                  </p>
                  <p className="text-base" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2074">
                    Shooters work through 14 steps from "Provisional Marksman"
                    to "Expert Marksman" and are eligible for the respective
                    badges and patches as they progress. Completion through
                    expert usually takes 2-4 years.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-2075">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-2076">
                  <UsersIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-2077" />
                </div>
                <div data-id="element-2078">
                  <h3 className="text-base font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-2079">
                    Parental Involvement
                  </h3>
                  <p className="text-base" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2080">
                    The team requests that a parent or guardian is present while
                    the student is shooting. With prior approval, exceptions may
                    be occasionally possible.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}